import type { ComposerLlm } from './types';

/**
 * Safe default (ADR-053): resolves to a generation-unavailable sentinel that
 * never Zod-parses as a valid plan, so downstream treats it as a generation
 * failure and takes the deterministic fallback tier — previews and tests get
 * reproducible compositions without a model call.
 */
export const noopComposerLlm: ComposerLlm = {
  plan: () => Promise.resolve({ unavailable: true, provider: 'noop' }),
};
